var _rect, _path, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningTwoToned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.25,
    width: 22.5,
    height: 22.5,
    rx: 11.25,
    fill: "var(--red-3)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5069 7.16406H13.1591L13.0473 15.0594H11.6187L11.5069 7.16406ZM11.333 17.2652C11.333 16.9204 11.4282 16.6313 11.6187 16.3981C11.8092 16.1648 12.0452 16.0482 12.3268 16.0482C12.6167 16.0482 12.8568 16.1648 13.0473 16.3981C13.2378 16.6313 13.333 16.9204 13.333 17.2652C13.333 17.6201 13.2378 17.9142 13.0473 18.1475C12.8568 18.3808 12.6167 18.4974 12.3268 18.4974C12.0452 18.4974 11.8092 18.3808 11.6187 18.1475C11.4282 17.9041 11.333 17.61 11.333 17.2652Z",
    fill: "var(--red-5)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 1.25,
    width: 22.5,
    height: 22.5,
    rx: 11.25,
    stroke: "var(--red-4)",
    strokeWidth: 1.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTwoToned);
export default __webpack_public_path__ + "static/media/warningTwoToned.83f163ffe8575301cdff87843d6e87ba.svg";
export { ForwardRef as ReactComponent };